import axios from 'axios';
import { responseInterceptor, errorInterceptor } from './interceptors';

const getStoredToken = () => {
  const tokenFromLocalStorage = localStorage.getItem('APP_ACCESS_TOKEN');
  if (!tokenFromLocalStorage) return '';

  try {
    return JSON.parse(tokenFromLocalStorage);
  } catch {
    localStorage.removeItem('APP_ACCESS_TOKEN');
    return '';
  }
};

const ApiLogin = axios.create({
  baseURL: window.env.REACT_APP_URL_BASELOGIN,
});

// Mesmo motivo do axiosApi: sem isso o Authorization ficava fixo no valor lido do
// localStorage na primeira vez que este módulo era avaliado, em vez de acompanhar o
// usuário logado no momento de cada requisição.
ApiLogin.interceptors.request.use((config) => {
  const storedToken = getStoredToken();
  config.headers.Authorization = storedToken ? `Bearer ${storedToken}` : '';
  return config;
});

ApiLogin.interceptors.response.use(
  (response) => responseInterceptor(response),
  (error) => errorInterceptor(error),
);

export { ApiLogin };